import { Component, EventEmitter, Output } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { UserGroupGet, UserGroupService } from '@app/services/user-group.service';

@Component({
    selector: 'tt-user-group',
    templateUrl: './user-group.component.html',
    styleUrls: ['./user-group.component.css'],
})
export class UserGroupComponent {
    get?: UserGroupGet;

    grid?: GridOptions;
    gridwebpage?: GridOptions;

    selectedTabId: string = 'USERS';

    @Output()
    public submit = new EventEmitter<{ usergroup_keyno: `${number}` | number } | undefined>();

    public saving = false;

    public deleting = false;

    constructor(private userGroup: UserGroupService) {
        userGroup.currentUserGroup$.subscribe({ next: this.setGet });
    }

    public async save() {
        if (!this.get) return;

        try {
            this.saving = true;

            const response = await this.userGroup.saveUserGroup(this.get);
            this.submit.emit(response);
        } catch (error) {
            console.error(error);
        } finally {
            this.saving = false;
        }
    }

    public async deleteUserGroup() {
        if (!this.get) return;

        try {
            this.deleting = true;

            await this.userGroup.deleteUserGroup(this.get);
            this.submit.emit();
        } catch (error) {
            console.error(error);
        } finally {
            this.deleting = false;
        }
    }

    private setGet = (get: UserGroupGet | null) => {
        if (get) {
            this.get = get;
            this.readGrid();
        } else {
            delete this.get;
            delete this.grid;
            delete this.gridwebpage;
        }
    };

    private readGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_usergroup.grid').setLoadDataFunction({ method: 3829, parameters: () => this.get });
        } else {
            this.grid.gridfunc?.read();
        }

        if (!this.gridwebpage) {
            this.gridwebpage = new Grid().setRememberId('w_usergroup.gridwebpage').setLoadDataFunction({ method: 3923, parameters: () => this.get });
        } else {
            this.gridwebpage.gridfunc?.read();
        }
    }
}
